import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
export default window.addEventListener('keydown', event => {
    console.log(event)
    if (event.keyCode === 27) {
        keyevent.$emit('esc');
    } else if (event.keyCode === 16) {
        keyevent.$emit('shift');
    } else if (event.keyCode === 46){
        keyevent.$emit('delete');
    } else if(event.keyCode === 13){
        keyevent.$emit('enter');
    }
})